import { createNotificationEndpoint } from 'root/src/server/modules/notification/endpoints/createNotification.endpoint';
export const notificationEndpoints = Object.assign({}, createNotificationEndpoint);
